import { IUpdateProcessoAuditoriaUseCase } from "../../../presentation/useCases/update/update_processo_auditoria_servicos_use_case";
import { IAuditorRepository } from "../../repositories/auditor_repository";

export class UpdateProcessoAuditoriaUseCase implements IUpdateProcessoAuditoriaUseCase {
  constructor(private readonly repository: IAuditorRepository) {}

  async updateProcessoAuditoria(
    IdProcesso: number,
    IdAuditoria: number,
    Descricao: string | null,
    IdFuncionario: number | null,
    DescResponsavel: string | null,
    ResponsavelCadastrado: boolean | null,
    Data: Date | null,
    Horario: string | null,
    RequisitoNormativo: string | null,
    Local: number | null,
    
  ): Promise<void> {
    await this.repository.updateProcessoAuditoria(
      IdProcesso,
      IdAuditoria,
      Descricao,
      IdFuncionario,
      DescResponsavel,
      ResponsavelCadastrado,
      Data,
      Horario,
      RequisitoNormativo,
      Local,
    );
  }
}
